/**
 * Registers the service worker — and only in a real build.
 *
 * `import.meta.env.PROD` guards it because the inner dev loop deliberately
 * has no service worker (design §1.3): architecture §11.1 says dev-mode SW
 * behaviour is not evidence, and the cheapest way to honour that is to make
 * dev-mode SW behaviour not exist.
 */
export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | undefined> {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return undefined
  return navigator.serviceWorker.register('/sw.js', { type: 'module' })
}
